export const SCENES = [
  {
    id: 0,
    name: 'Intro',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 1,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646788433967-1646788433967.tmp',
        name: '01 Intro-1.m4v',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 27.2,
          angleVert: 0,
          heightHor: 96.7,
          widthVert: 113.6,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50.1,
          yPercentageHor: 48.4,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: false,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "6"',
        selected: false,
        startTime: 0,
        collapsed: false,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset1',
        interactionType: 'None',
      },
      {
        id: 2,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787228508-1646787228508.tmp',
        name: 'red.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 8.1,
          angleVert: 0,
          heightHor: 17.7,
          widthVert: 33.5,
          heightVert: 18.5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 57.3,
          xPercentageVert: 50,
          yPercentageVert: 72.2,
        },
        endTime: 0.0562,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Bubble',
        collapsed: false,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: 'CMPIVAsset2',
        interactionType: 'Tap',
      },
      {
        id: 3,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787235114-1646787235114.tmp',
        name: 'text_red.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 15.3,
          angleVert: 0,
          heightHor: 18,
          widthVert: 23.6,
          heightVert: 7,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50.1,
          yPercentageHor: 85.8,
          xPercentageVert: 50.6,
          yPercentageVert: 88.8,
        },
        endTime: 0.0562,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: false,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset3',
        interactionType: 'None',
      },
      {
        id: 4,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787259698-1646787259698.tmp',
        name: 'pointer.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 313,
          widthHor: 8,
          angleVert: 326,
          heightHor: 32.8,
          widthVert: 23.7,
          heightVert: 24.5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 58.1,
          yPercentageHor: 69.4,
          xPercentageVert: 80.1,
          yPercentageVert: 87.8,
        },
        endTime: 0.0562,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Bounce',
        collapsed: false,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset4',
        interactionType: 'None',
      },
      {
        id: 5,
        url: false,
        name: 'New Image',
        type: 'Image',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 15,
          angleVert: 0,
          heightHor: 15,
          widthVert: 113.2,
          heightVert: 98.5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50.2,
          yPercentageVert: 50.1,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: true,
        selected: false,
        startTime: 0,
        btnEffect: 'Rotate',
        collapsed: false,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Start Scene "6"',
        onClickUrl: '',
        currentImage: false,
        interactionType: 'Tap',
      },
    ],
    selected: false,
    collapsed: false,
    isEndcard: false,
    sceneLength: 3.328,
    orientationLock: 'Portrait',
  },
  {
    id: 6,
    name: 'Red',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 7,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787349276-1646787349276.tmp',
        name: 'Red-1.m4v',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 27.7,
          angleVert: 0,
          heightHor: 98.1,
          widthVert: 113.2,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 49.7,
          yPercentageHor: 49,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: true,
        children: [],
        isHidden: false,
        onVidFin: 'None',
        selected: false,
        startTime: 0,
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset7',
        interactionType: 'None',
      },
      {
        id: 8,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787417026-1646787417026.tmp',
        name: 'logo.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 25.5,
          widthVert: 87.7,
          heightVert: 11,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 13.8,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset8',
        interactionType: 'None',
      },
      {
        id: 9,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787427214-1646787427214.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 33.1,
          widthVert: 50.4,
          heightVert: 8,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 49.8,
          yPercentageVert: 92.9,
        },
        endTime: -1,
        iosUrl: 'https://apps.apple.com/us/app/angry-birds-2/id880047117',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: 'https://play.google.com/store/apps/details?id=com.rovio.baba&hl=en&gl=us',
        loadedName: false,
        onBtnClick: 'Open App Store URL',
        onClickUrl: 'craftsmanplus.com',
        currentImage: 'CMPIVAsset9',
        interactionType: 'Tap',
      },
      {
        id: 10,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787595936-1646787595936.tmp',
        name: 'box.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 33.4,
          angleVert: 0,
          heightHor: 50,
          widthVert: 150.6,
          heightVert: 56,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 49.8,
          yPercentageVert: 58,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset10',
        interactionType: 'None',
      },
      {
        id: 11,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787634722-1646787634722.tmp',
        name: 'text_next.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 17.5,
          widthVert: 66.3,
          heightVert: 6,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 38.9,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset11',
        interactionType: 'None',
      },
      {
        id: 12,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787643608-1646787643608.tmp',
        name: 'chuck.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 28.1,
          angleVert: 0,
          heightHor: 50,
          widthVert: 31.5,
          heightVert: 14,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'Bubble',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Start Scene "18"',
        onClickUrl: '',
        currentImage: 'CMPIVAsset12',
        interactionType: 'Tap',
      },
      {
        id: 13,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787652794-1646787652794.tmp',
        name: 'matilda.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 23,
          angleVert: 0,
          heightHor: 50,
          widthVert: 25.4,
          heightVert: 14,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 75,
          yPercentageVert: 69.8,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'Bubble',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Start Scene "22"',
        onClickUrl: '',
        currentImage: 'CMPIVAsset13',
        interactionType: 'Tap',
      },
      {
        id: 14,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787664136-1646787664136.tmp',
        name: 'bomb.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 19.2,
          angleVert: 0,
          heightHor: 50,
          widthVert: 24.8,
          heightVert: 16,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 24.6,
          yPercentageVert: 68.8,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'Bubble',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Start Scene "20"',
        onClickUrl: '',
        currentImage: 'CMPIVAsset14',
        interactionType: 'Tap',
      },
      {
        id: 15,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787688879-1646787688879.tmp',
        name: 'text_chuck.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 36.4,
          widthVert: 18.8,
          heightVert: 3,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 51.3,
          yPercentageVert: 60.8,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset15',
        interactionType: 'None',
      },
      {
        id: 16,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787707873-1646787707873.tmp',
        name: 'text_bomb.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 41.8,
          widthVert: 17.8,
          heightVert: 4,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 24.6,
          yPercentageVert: 79.7,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset16',
        interactionType: 'None',
      },
      {
        id: 17,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787719309-1646787719309.tmp',
        name: 'text_matilda.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 24.6,
          widthVert: 28.5,
          heightVert: 4,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 76.6,
          yPercentageVert: 79.9,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 4.5117,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset17',
        interactionType: 'None',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 4.587,
    orientationLock: 'Portrait',
  },
  {
    id: 18,
    name: 'Chuck',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 19,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787846517-1646787846517.tmp',
        name: 'Chuck-1.m4v',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 14.1,
          angleVert: 0,
          heightHor: 50,
          widthVert: 113.6,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: true,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "24"',
        selected: false,
        startTime: 0,
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset19',
        interactionType: 'None',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 5.067,
    orientationLock: 'Portrait',
  },
  {
    id: 22,
    name: 'Matilda',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 23,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787885169-1646787885169.tmp',
        name: 'Matilda-1.m4v',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 14.1,
          angleVert: 0,
          heightHor: 50,
          widthVert: 113.6,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: true,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "24"',
        selected: false,
        startTime: 0,
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset23',
        interactionType: 'None',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 2.944,
    orientationLock: 'Portrait',
  },
  {
    id: 20,
    name: 'Bomb',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 21,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787865100-1646787865100.tmp',
        name: 'Bomb-1.m4v',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 14.1,
          angleVert: 0,
          heightHor: 50,
          widthVert: 113.6,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: true,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "24"',
        selected: false,
        startTime: 0,
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset21',
        interactionType: 'None',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 5.376,
    orientationLock: 'Portrait',
  },
  {
    id: 24,
    name: 'Gameplay',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 26,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787970512-1646787970512.tmp',
        name: 'Gameplay-1.m4v',
        type: 'Video',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 14.1,
          angleVert: 0,
          heightHor: 50,
          widthVert: 113.6,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: true,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "25"',
        selected: true,
        startTime: 0,
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset26',
        interactionType: 'None',
      },
      {
        id: 27,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787417026-1646787417026.tmp',
        name: 'logo.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 25.5,
          widthVert: 87.7,
          heightVert: 11,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 7.2,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset27',
        interactionType: 'None',
      },
      {
        id: 28,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787427214-1646787427214.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 50,
          angleVert: 0,
          heightHor: 33.1,
          widthVert: 50.4,
          heightVert: 8,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 92.9,
        },
        endTime: -1,
        iosUrl: 'https://apps.apple.com/us/app/angry-birds-2/id880047117',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Bubble',
        collapsed: true,
        androidUrl: 'https://play.google.com/store/apps/details?id=com.rovio.baba&hl=en&gl=us',
        loadedName: false,
        onBtnClick: 'Open App Store URL',
        onClickUrl: '',
        currentImage: 'CMPIVAsset28',
        interactionType: 'Tap',
      },
    ],
    selected: true,
    collapsed: true,
    isEndcard: false,
    sceneLength: 6.038,
    orientationLock: 'Portrait',
  },
  {
    id: 25,
    name: 'End Card',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 29,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646788034037-1646788034037.tmp',
        name: 'background.jpg',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 200,
          widthVert: 200,
          heightVert: 100,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 50,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset29',
        interactionType: 'None',
      },
      {
        id: 30,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646788129226-1646788129226.tmp',
        name: 'end_art (1).png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 67.2,
          angleVert: 0,
          heightHor: 120.5,
          widthVert: 111.2,
          heightVert: 50,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 32.9,
          xPercentageVert: 44.4,
          yPercentageVert: 53.4,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset30',
        interactionType: 'None',
      },
      {
        id: 31,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646787427214-1646787427214.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 23.9,
          angleVert: 0,
          heightHor: 15.8,
          widthVert: 63.4,
          heightVert: 10,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 51.5,
          yPercentageHor: 57.9,
          xPercentageVert: 50,
          yPercentageVert: 87.6,
        },
        endTime: -1,
        iosUrl: 'https://apps.apple.com/us/app/angry-birds-2/id880047117',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Bubble',
        collapsed: true,
        androidUrl: 'https://play.google.com/store/apps/details?id=com.rovio.baba&hl=en&gl=us',
        loadedName: false,
        onBtnClick: 'Open App Store URL',
        onClickUrl: '',
        currentImage: 'CMPIVAsset31',
        interactionType: 'Tap',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: true,
    sceneLength: 0,
    orientationLock: 'Portrait',
  },
  {
    id: 'fred',
    name: 'New Scene 1',
    type: 'Scene',
    children: [],
    selected: true,
    collapsed: false,
    isEndcard: false,
  },
];

export const HOTSPOTSCENES = [
  {
    id: 0,
    name: 'Scene 1',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 14,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646282973925-1646282973925.tmp',
        name: 'Video 1.mp4',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 112.5,
          widthVert: 50,
          heightVert: 14,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 43.7,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: false,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "16"',
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset14',
        interactionType: 'None',
      },
      {
        id: 2,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646280749816-1646280749816.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 21.4,
          angleVert: 0,
          heightHor: 12,
          widthVert: 50,
          heightVert: 7,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 86,
          yPercentageHor: 9.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Open App Store URL',
        onClickUrl: '',
        currentImage: 'CMPIVAsset2',
        interactionType: 'Tap',
      },
      {
        id: 33,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283500018-1646283500018.tmp',
        name: 'text_box.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 36.7,
          angleVert: 0,
          heightHor: 11.7,
          widthVert: 50,
          heightVert: 4,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 87.2,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: 0.0241,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset33',
        interactionType: 'None',
      },
      {
        id: 34,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
        name: 'Swipe to skate',
        type: 'Font',
        config: {
          size: '7',
          text: 'Swipe to skate',
          align: 'left',
          alpha: 1,
          color: '#1c1c1c',
          state: 0,
          style: 'normal',
          family: 'PermanentMarker-x99j',
          angleHor: 0,
          widthHor: 28.7,
          angleVert: 0,
          heightHor: 12.5,
          widthVert: 30,
          heightVert: 25,
          textBaseline: 'top',
          xPercentageHor: 52.2,
          yPercentageHor: 89.1,
          xPercentageVert: 35,
          yPercentageVert: 21.9,
        },
        edited: true,
        endTime: 0.0241,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        onBtnClick: 'None',
        onClickUrl: '',
        currentText: 'PermanentMarker-x99j',
        interactionType: 'None',
      },
      {
        id: 35,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283666059-1646283666059.tmp',
        name: 'arrows.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 14.8,
          angleVert: 0,
          heightHor: 7.4,
          widthVert: 50,
          heightVert: 6,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 70.8,
          xPercentageVert: 50,
          yPercentageVert: 79.8,
        },
        endTime: 0.0241,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Slide',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: 'CMPIVAsset35',
        interactionType: 'None',
      },
      {
        id: 40,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646284081236-1646284081236.tmp',
        name: 'logo.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 24.1,
          angleVert: 0,
          heightHor: 10.3,
          widthVert: 50,
          heightVert: 5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 16.3,
          yPercentageHor: 8.9,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset40',
        interactionType: 'None',
      },
      {
        id: 39,
        url: false,
        name: 'Hit Area',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 74.4,
          widthVert: 15,
          heightVert: 15,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 62.8,
          xPercentageVert: 50,
          yPercentageVert: 75.3,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: false,
        interactionType: 'Swipe Right',
      },
      {
        id: 'o5905',
        name: 'New Hotspot 1',
        type: 'Hotspot',
        config: {
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 74.9,
          widthVert: 50,
          heightVert: 50,
          aspectLockHor: false,
          aspectLockVert: false,
          xPercentageHor: 50,
          yPercentageHor: 62.5,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        isHidden: false,
        startTime: 0,
        btnEffect: 'None',
        androidUrl: '',
        onBtnClick: 'Play Video',
        onClickUrl: '',
        interactionType: 'Swipe Right',
      },
    ],
    selected: true,
    collapsed: true,
    isEndcard: false,
    sceneLength: 1.472,
    orientationLock: 'Landscape',
  },
  {
    id: 16,
    name: 'Scene 2',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 17,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646282991643-1646282991643.tmp',
        name: 'Video 2.mp4',
        type: 'Video',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 112.5,
          widthVert: 50,
          heightVert: 14,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 43.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: false,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "21"',
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset17',
        interactionType: 'None',
      },
      {
        id: 29,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646280749816-1646280749816.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 19.1,
          angleVert: 0,
          heightHor: 10.7,
          widthVert: 50,
          heightVert: 7,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 87.6,
          yPercentageHor: 10.3,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Open URL',
        onClickUrl: 'https://apps.apple.com/us/app/skate-city/id1182476302',
        currentImage: 'CMPIVAsset29',
        interactionType: 'Tap',
      },
      {
        id: 41,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646284081236-1646284081236.tmp',
        name: 'logo.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 24.1,
          angleVert: 0,
          heightHor: 10.3,
          widthVert: 50,
          heightVert: 5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 15.1,
          yPercentageHor: 10.6,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset41',
        interactionType: 'None',
      },
      {
        id: 36,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283666059-1646283666059.tmp',
        name: 'arrows.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 180,
          widthHor: 17.1,
          angleVert: 0,
          heightHor: 8.6,
          widthVert: 50,
          heightVert: 6,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 77.7,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: 0.0454,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Slide',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: 'CMPIVAsset36',
        interactionType: 'None',
      },
      {
        id: 42,
        url: false,
        name: 'Hit Area',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 74.4,
          widthVert: 15,
          heightVert: 15,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 62.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: false,
        interactionType: 'Swipe Left',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 2.774,
    orientationLock: 'Landscape',
  },
  {
    id: 21,
    name: 'Scene 3',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 22,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283035931-1646283035931.tmp',
        name: 'Video 3.m4v',
        type: 'Video',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 112.5,
          widthVert: 50,
          heightVert: 14,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 43.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: false,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "24"',
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset22',
        interactionType: 'None',
      },
      {
        id: 30,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646280749816-1646280749816.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 19.1,
          angleVert: 0,
          heightHor: 10.7,
          widthVert: 50,
          heightVert: 7,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 87.6,
          yPercentageHor: 10.3,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Open URL',
        onClickUrl: 'https://apps.apple.com/us/app/skate-city/id1182476302',
        currentImage: 'CMPIVAsset30',
        interactionType: 'Tap',
      },
      {
        id: 44,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646284081236-1646284081236.tmp',
        name: 'logo.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 24.1,
          angleVert: 0,
          heightHor: 10.3,
          widthVert: 50,
          heightVert: 5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 15.1,
          yPercentageHor: 10.6,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset44',
        interactionType: 'None',
      },
      {
        id: 37,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283666059-1646283666059.tmp',
        name: 'arrows.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 270,
          widthHor: 17.1,
          angleVert: 0,
          heightHor: 8.6,
          widthVert: 50,
          heightVert: 6,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 67.1,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: 0.0475,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Slide',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: 'CMPIVAsset37',
        interactionType: 'None',
      },
      {
        id: 43,
        url: false,
        name: 'Hit Area',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 74.4,
          widthVert: 15,
          heightVert: 15,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 62.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: false,
        interactionType: 'Swipe Up',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 2.902,
    orientationLock: 'Landscape',
  },
  {
    id: 24,
    name: 'Scene 4',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 25,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283057716-1646283057716.tmp',
        name: 'Video 4.m4v',
        type: 'Video',
        config: {
          state: 1,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 112.5,
          widthVert: 50,
          heightVert: 14,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 43.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        hideTime: 1,
        showPct: 0,
        autoplay: false,
        children: [],
        isHidden: false,
        onVidFin: 'Start Scene "4"',
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentVideo: 'CMPIVAsset25',
        interactionType: 'None',
      },
      {
        id: 31,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646280749816-1646280749816.tmp',
        name: 'cta.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 19.1,
          angleVert: 0,
          heightHor: 10.7,
          widthVert: 50,
          heightVert: 7,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 87.6,
          yPercentageHor: 10.3,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Open URL',
        onClickUrl: 'https://apps.apple.com/us/app/skate-city/id1182476302',
        currentImage: 'CMPIVAsset31',
        interactionType: 'Tap',
      },
      {
        id: 45,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646284081236-1646284081236.tmp',
        name: 'logo.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 24.1,
          angleVert: 0,
          heightHor: 10.3,
          widthVert: 50,
          heightVert: 5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 15.1,
          yPercentageHor: 10.6,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset45',
        interactionType: 'None',
      },
      {
        id: 38,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283666059-1646283666059.tmp',
        name: 'arrows.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 90,
          widthHor: 17.1,
          angleVert: 0,
          heightHor: 8.6,
          widthVert: 50,
          heightVert: 6,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 67.1,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: 0.0874,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Slide',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: 'CMPIVAsset38',
        interactionType: 'None',
      },
      {
        id: 46,
        url: false,
        name: 'Hit Area',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 74.4,
          widthVert: 15,
          heightVert: 15,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 62.8,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Play Video',
        onClickUrl: '',
        currentImage: false,
        interactionType: 'Swipe Down',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: false,
    sceneLength: 5.334,
    orientationLock: 'Landscape',
  },
  {
    id: 4,
    name: 'End Card',
    type: 'Scene',
    config: {},
    children: [
      {
        id: 8,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646281461604-1646281461604.tmp',
        name: 'background.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 200,
          widthVert: 50,
          heightVert: 25,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 61.2,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset8',
        interactionType: 'None',
      },
      {
        id: 9,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646281485882-1646281485882.tmp',
        name: 'bar.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 100,
          angleVert: 0,
          heightHor: 28.1,
          widthVert: 50,
          heightVert: 4,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 86,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset9',
        interactionType: 'None',
      },
      {
        id: 10,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646281498802-1646281498802.tmp',
        name: 'Arcade.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 62.2,
          angleVert: 0,
          heightHor: 26.1,
          widthVert: 50,
          heightVert: 5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 50,
          yPercentageHor: 33.4,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset10',
        interactionType: 'None',
      },
      {
        id: 11,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646281518361-1646281518361.tmp',
        name: 'cta_end.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 22.6,
          angleVert: 0,
          heightHor: 10.3,
          widthVert: 50,
          heightVert: 6,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 84,
          yPercentageHor: 86,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'Bubble',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'Open URL',
        onClickUrl: 'https://apps.apple.com/us/app/skate-city/id1182476302',
        currentImage: 'CMPIVAsset11',
        interactionType: 'Tap',
      },
      {
        id: 12,
        url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646281532034-1646281532034.tmp',
        name: 'text_end.png',
        type: 'Image',
        config: {
          state: 0,
          angleHor: 0,
          widthHor: 40.7,
          angleVert: 0,
          heightHor: 16.6,
          widthVert: 50,
          heightVert: 5,
          aspectLockHor: true,
          aspectLockVert: true,
          xPercentageHor: 23.9,
          yPercentageHor: 86,
          xPercentageVert: 50,
          yPercentageVert: 50,
        },
        endTime: -1,
        iosUrl: '',
        children: [],
        isHidden: false,
        selected: false,
        startTime: 0,
        btnEffect: 'None',
        collapsed: true,
        androidUrl: '',
        loadedName: false,
        onBtnClick: 'None',
        onClickUrl: '',
        currentImage: 'CMPIVAsset12',
        interactionType: 'None',
      },
    ],
    selected: false,
    collapsed: true,
    isEndcard: true,
    sceneLength: 0.1,
    orientationLock: 'Landscape',
  },
];

export const SETTINGS = {
  BGAudio: {
    id: 'BGMusic',
    url: '',
    name: 'BGMusic',
    type: 'Audio',
    config: {},
    endTime: -1,
    children: [],
    isHidden: false,
    selected: false,
    startTime: 0,
    collapsed: false,
    loadedName: false,
    onAudioFin: 'Loop',
    currentAudio: false,
    playOnEndCard: true,
  },
  idCounter: 5,
  useBGAudio: false,
  fontConfigs: [
    {
      id: 2,
      url: 'https://s3.us-east-1.amazonaws.com/staging-elasticbeanstalk-environment-databucket-m72zlculvu3v/1655310939532_1655310939532.tmp',
      name: 'Neon Space Rocke.png',
      type: 'Image',
      config: {
        state: 0,
        angleHor: 0,
        widthHor: 50,
        angleVert: 0,
        heightHor: 42.7,
        widthVert: 50,
        heightVert: 10.7,
        aspectLockHor: true,
        aspectLockVert: true,
        xPercentageHor: 50,
        yPercentageHor: 50,
        xPercentageVert: 50,
        yPercentageVert: 50,
      },
      endTime: -1,
      iosUrl: '',
      children: [],
      isHidden: false,
      selected: true,
      startTime: 0,
      btnEffect: 'None',
      collapsed: false,
      androidUrl: '',
      loadedName: 'Neon Space Rocke.png',
      onBtnClick: 'None',
      onClickUrl: '',
      currentImage: 'CMPIVAsset2',
      interactionType: 'None',
    },
  ],
  orientation: 'Portrait',
  orientationLock: 'Portrait',
};

export const SETTINGSLS = {
  BGAudio: {
    id: 'BGMusic',
    url: '',
    name: 'BGMusic',
    type: 'Audio',
    config: {},
    endTime: -1,
    children: [],
    isHidden: false,
    selected: false,
    startTime: 0,
    collapsed: false,
    loadedName: false,
    onAudioFin: 'Loop',
    currentAudio: false,
    playOnEndCard: true,
  },
  idCounter: 5,
  useBGAudio: false,
  fontConfigs: [
    {
      id: 2,
      url: 'https://s3.us-east-1.amazonaws.com/staging-elasticbeanstalk-environment-databucket-m72zlculvu3v/1655310939532_1655310939532.tmp',
      name: 'Neon Space Rocke.png',
      type: 'Image',
      config: {
        state: 0,
        angleHor: 0,
        widthHor: 50,
        angleVert: 0,
        heightHor: 42.7,
        widthVert: 50,
        heightVert: 10.7,
        aspectLockHor: true,
        aspectLockVert: true,
        xPercentageHor: 50,
        yPercentageHor: 50,
        xPercentageVert: 50,
        yPercentageVert: 50,
      },
      endTime: -1,
      iosUrl: '',
      children: [],
      isHidden: false,
      selected: true,
      startTime: 0,
      btnEffect: 'None',
      collapsed: false,
      androidUrl: '',
      loadedName: 'Neon Space Rocke.png',
      onBtnClick: 'None',
      onClickUrl: '',
      currentImage: 'CMPIVAsset2',
      interactionType: 'None',
    },
  ],
  orientation: 'Landscape',
  orientationLock: 'Landscape',
};
